import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  CardContent,
  CardMedia,
  Grid,
  Container, Card,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  useTheme,
  CircularProgress,
  Alert
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WarningIcon from '@mui/icons-material/Warning';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import SendIcon from '@mui/icons-material/Send';
import { useSelector } from 'react-redux';
import { apiServices } from '../../../../services/apiServices';

const videos = [
  {
    title: 'Global Justice, Love & Peace Summit',
    description: 'Keynotes & Speeches Archive',
    url: 'https://www.youtube.com/embed/oj2J-jciWgM',
  },
  {
    title:
      'Wockhardt Foundation: Purposeful Leadership, Health and Sustainability',
    description: '5th Good Air Summit',
    url: 'https://www.youtube.com/embed/AdDHerbXbxY',
  },
];

const Dashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // State for dashboard data
  const [dashboardData, setDashboardData] = useState({
    totalReferred: 0,
    completed: 0,
    pending: 0
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  // Get user from Redux state
  const { user } = useSelector((state) => state.auth);

  // Fetch invitations data
  const fetchInvitationsData = async () => {
    if (!user?.peacekeeper_id) {
      setError('Peacekeeper ID not found');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);
      
      const response = await apiServices.getAPI(`invitations/${user.peacekeeper_id}`);
      
      if (response && response.status >= 200 && response.status < 300) {
        const data = response.data;
        console.log('Invitations API Response:', data);
        
        // Handle the API response format
        let invitationsArray = [];
        
        if (data && data.invitations && Array.isArray(data.invitations)) {
          // API returns { message, count, peacekeeperId, invitations: [...] }
          invitationsArray = data.invitations;
        } else if (Array.isArray(data)) {
          // Fallback: direct array response
          invitationsArray = data;
        } else {
          console.warn('Unexpected invitations API response format:', data);
          invitationsArray = [];
        }
        
        // Calculate dashboard metrics
        const totalReferred = invitationsArray.length;
        const completed = invitationsArray.filter(invite => 
          invite.status && invite.status.toUpperCase() === 'ACCEPTED'
        ).length;
        const pending = invitationsArray.filter(invite => 
          invite.status && invite.status.toUpperCase() === 'SENT'
        ).length;
        
        setDashboardData({
          totalReferred,
          completed,
          pending
        });
      } else {
        throw new Error(`HTTP ${response?.status}: ${response?.statusText}`);
      }
    } catch (err) {
      console.error('Error fetching invitations data:', err);
      setError(err.message || 'Failed to fetch invitations data');
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchInvitationsData();
  }, [user?.peacekeeper_id]);

  // Dynamic card data based on API response
  const cardData = [
    {
      icon: <PeopleIcon style={{ color: '#fff' , backgroundColor: '#a0c84e' , padding:'8px' , fontSize:"35px" , borderRadius:"5px"}} />,
      label: 'Total Referred',
      value: dashboardData.totalReferred,
    },
    {
      icon: <CheckCircleIcon fontSize="medium" style={{ color: '#fff' ,backgroundColor: '#3ec6c0' , padding:'8px' , fontSize:"35px" , borderRadius:"5px" }} />,
      label: 'Completed',
      value: dashboardData.completed,
    },
    {
      icon: <PendingActionsIcon fontSize="medium" style={{ color: '#fff' ,backgroundColor: '#f2645a' ,padding:'8px' , fontSize:"35px" , borderRadius:"5px" }} />,
      label: 'Pending',
      value: dashboardData.pending,
    },
  ];

  const recentActivities = [
    {
      icon: <SendIcon color="error" style={{ color: '#fff' , backgroundColor: '#DF5B55' , padding:'8px' , fontSize:"35px" , borderRadius:"50px"}} />,
      title: 'Invitation Sent',
      description: 'Invitation activity recorded',
      time: '',
    },
    {
      icon: <PersonAddAltIcon color="success"  style={{ color: '#fff' , backgroundColor: '#86CDBE' , padding:'8px' , fontSize:"35px" , borderRadius:"50px"}}/>,
      title: 'Referral Joined',
      description: 'Referral activity recorded',
      time: '',
    },
  ];

  // Loading state
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
        <CircularProgress />
      </Box>
    );
  }

  // Error state
  if (error) {
    return (
      <Box sx={{ py: 2 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Button 
          variant="contained" 
          onClick={fetchInvitationsData}
          sx={{ backgroundColor: '#FFD600', color: '#0c5c88' }}
        >
          Retry
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ py: 2 }} className='dashboardMainContainer'>
      {/* <Typography variant="h4" gutterBottom fontWeight={600}>
        Keynotes & Speeches Archive
      </Typography> */}

      {/* <Grid container spacing={4}>
        {videos.map((video, index) => (
          <Grid size={{ xs: 12, md: 6 }} key={index}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
              }}
              elevation={3}
            >
              <CardMedia
                component="iframe"
                src={video.url}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                sx={{
                  height: {
                    xs: 200,
                    sm: 250,
                    md: 300,
                  },
                  border: 0,
                }}
              />
              <CardContent>
                <Typography variant="h6" fontWeight={100} className='videoTitle'>
                  {video.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {video.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid> */}

      
      <Grid container spacing={2}>
        {cardData.map((card, index) => (
          <Grid size={{ xs: 12, sm:6 , md:4 }} key={index}>
            <Card>
              <CardContent className='pb-16px'>
              <Box display="flex" justifyContent="start" alignItems="center" gap={2}> 
                   {card.icon}
                <Typography fontWeight="800" fontSize="20px">{card.value}</Typography>
              </Box>
               
                <Box mt={2}>
                  
                  <Typography variant="body2" color="textSecondary" className='cardLabel'>
                    {card.label}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Recent Activity Section */}
      <Box mt={4}>
       
        <Card sx={{padding:"15px"}}>
         <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography fontWeight="800">Recent Activity</Typography>
          {/* <Button variant="contained" style={{ backgroundColor: '#FFD600', color: '#0c5c88' , textTransform:'capitalize' }}>
            View All
          </Button> */}
        </Box>

          <List>
            {recentActivities.map((activity, index) => (
              <ListItem key={index}>
                <ListItemIcon>{activity.icon}</ListItemIcon>
                <ListItemText
                  primary={activity.title}
                  secondary={
                    <React.Fragment>
                      <Typography component="span" variant="body2" color="text.secondary">
                        {activity.description}
                      </Typography>
                    </React.Fragment>
                  }
                />
                <Typography variant="body2" color="text.secondary">
                  {activity.time}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Card>
      </Box>
    
    </Box>
  );
};

export default Dashboard;
